import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

/** The Industry filter's "all" option; the industries themselves are the shared borrower-industry list (useBorrowerIndustries). */
export const ALL_INDUSTRIES_OPTION = "All Industries";
export const OFFICE_OPTIONS = [
  "All Offices",
  "Dealer Services",
  "Strategic Accounts",
  "Partner Funding",
  "Enterprise Dealer",
] as const;
export const RATING_OPTIONS = ["All Ratings", "A1", "B1", "B2", "B3", "C"] as const;
export const PG_CORP_OPTIONS = ["All", "PG", "Corp"] as const;
export const ACTIVE_OPTIONS = ["All", "Active", "Inactive"] as const;
export const TICKET_SIZE_OPTIONS = ["All", "Over $250K", "Under $250K"] as const;

export interface PoolBuilderResult {
  matchedContracts: number;
  matchedNI: string;
  summaryReady: boolean;
}

// null -- skipped at the user's own request. Render an empty state, not a
// fabricated match count.
export function usePoolBuilder(filters: Record<string, string>) {
  return useQuery({
    queryKey: ["pool-builder", filters],
    queryFn: () => apiGet<PoolBuilderResult | null>("/pool-builder", filters),
  });
}
